import React, { Component } from 'react'
import './css/common.css'

export class responsible extends Component {
  render () {
    return (
      <div id='container'>
        <div className='row justify-content-md-center'>
          <div>
            <h3>Under Construction <span role='img' aria-label='worker'>&#128119;</span></h3>
            <p>Do check out after sometime</p>
          </div>
        </div>
      </div>
    )
  }
}

export default responsible
